import React from 'react'
import Auth from '../screens/Auth'
import { useDialog } from '../hooks/useDialog'

// SessionExpired covers the app once her session has ended while it was open
// (signed out on another device, or expired). One calm message replaces every
// "Something went wrong"; the app stays underneath, so an open sheet keeps
// what she typed, and signing in here takes her straight back to it.
export default function SessionExpired() {
  const ref = React.useRef<HTMLDivElement>(null)
  useDialog(ref, () => {}, { closable: false })
  return (
    <div className="session-overlay">
      <div ref={ref} className="session-card" role="dialog" aria-modal="true" aria-labelledby="session-expired-title">
        <Auth expired />
      </div>
    </div>
  )
}
